export enum MessengerType {
    TELEGRAM = 'telegram',
    VK = 'vk',
    MAX = 'max'
}